import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      margin: theme.spacing(1.25, 0, 4),
    },
    title: {
      marginBottom: theme.spacing(5),
      fontSize: theme.typography.pxToRem(20),
      lineHeight: theme.typography.pxToRem(24),
      fontWeight: theme.typography.fontWeightMedium,
      textAlign: 'center',
    },
    tabs: {
      width: 'fit-content',
      maxWidth: '610px',
      margin: '0 auto',
      color: theme.palette.text.secondary,
      borderBottom: theme.shape.borderGray,
    },
    indicator: {
      height: '2px',
    },
    tab: {
      padding: theme.spacing(1.5, 2.25, 1.5),
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      color: theme.palette.text.secondary,
      textTransform: 'capitalize',

      '& + &': {
        marginLeft: theme.spacing(0),
      },
    },
  }),
  { name: 'MultipleVideoTabs' }
);
